<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Formas de Pagamento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            width="600"
            lazy
            :fullscreen="$vuetify.breakpoint.xs"
            hide-overlay
          >
            <v-btn icon color="info" slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-forma-pagamento
              v-on:fechar="dialog = false"
              v-on:complete="success"
              v-on:error="showError"
            ></cad-forma-pagamento>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="formasPagHeaders"
          :items="formasPag"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="headerCell" slot-scope="{ header }">
            <span class="font-weight-light" v-text="header.text" />
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.descricao }}</td>
            <td class="text-xs-left">{{ props.item.url }}</td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.em_producao" size="30">check_circle</v-icon>
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.aceita_credito" size="30">check_circle</v-icon>
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.aceita_debito" size="30">check_circle</v-icon>
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>

            <td class="text-xs-left">{{ props.item.endpoint_producao }}</td>
            <td class="text-xs-left">{{ props.item.endpoint_homologacao }}</td>
            <td class="text-xs-right">
              <v-btn icon flat color="info" @click="editarFormaPag(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-right">
              <v-btn icon @click="selecionarPagamento(props.item)">
                <v-icon color="error">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogEditarFormaPag" width="500" lazy :fullscreen="$vuetify.breakpoint.xs">
      <editar-forma-pagamento
        v-on:fechar="dialogEditarFormaPag = false"
        v-on:complete="success"
        v-on:error="showError"
        v-on:info="showInfo"
      ></editar-forma-pagamento>
    </v-dialog>
    <v-dialog lazy width="300" v-model="dialogCancelamento">
      <v-card>
        <v-card-text
          v-text="
            `Tem certeza que deseja apagar a forma de pagamento ${
              pagamento_selected ? pagamento_selected.descricao : 0
            }?`
          "
          class="headline primary--text text-xs-center"
        ></v-card-text>
        <v-card-actions>
          <v-btn flat block color="green" @click="dialogCancelamento = false">CANCELAR</v-btn>
          <v-btn flat block color="error" @click="apagarPagamento()">CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CadFormaPagamento from '@/components/cadastros/CadFormaPagamento'
import EditarFormaPagamento from '@/components/dialogs/DialogEditarFormaPagamento'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: { CadFormaPagamento, EditarFormaPagamento, SmartLockMessage },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagamento_selected: null,
      dialogEditarFormaPag: false,
      dialog: false,
      dialogCancelamento: false,
      pagination: {},
      formasPagHeaders: [
        {
          text: 'Descrição',
          align: 'left',
          sortable: false,
          value: 'descricao'
        },
        {
          text: 'URL de pagamento',
          align: 'left',
          sortable: false,
          value: 'url'
        },
        {
          text: 'Em produção',
          align: 'center',
          sortable: false
        },
        {
          text: 'Crédito',
          align: 'center',
          sortable: false
        },
        {
          text: 'Debito',
          align: 'center',
          sortable: false
        },
        {
          text: 'Endpoint produção',
          align: 'left',
          sortable: false
        },
        {
          text: 'Endpoint homologação',
          align: 'left',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    formasPag () {
      return this.$store.getters.formasPag
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    totalItems () {
      return this.$store.getters.totalItemsFormasPag
    }
  },
  watch: {
    pagination: {
      handler () {
        this.$store.dispatch('carregarFormasPagamento', this.pagination)
      },
      deep: true
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('carregarFormasPagamento', this.pagination)
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('carregarFormasPagamento', this.pagination)
    }
  },
  methods: {
    success (messages) {
      this.$store.dispatch('carregarFormasPagamento', this.pagination)
      this.dialogEditarFormaPag = false
      this.dialog = false
      this.showInfo(messages)
    },
    selecionarPagamento (pagamento) {
      this.pagamento_selected = pagamento
      this.dialogCancelamento = true
    },
    apagarPagamento () {
      this.$store
        .dispatch(
          'apagarFormasPagamento',
          this.pagamento_selected.id_forma_pagamento
        )
        .then(info => {
          this.$store.dispatch('carregarFormasPagamento', this.pagination)
          this.dialogCancelamento = false
          this.showInfo(info)
        })
        .catch(error => {
          this.dialogCancelamento = false
          this.showError(error)
        })
    },
    editarFormaPag (formaPag) {
      this.dialogEditarFormaPag = true
      this.$store.dispatch('selectFormaPagamento', formaPag)
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
